module.exports = __webpack_public_path__ + "static/media/summary_03.93fe3fbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/news/images/summary_03.png
// module id = 1204
// module chunks = 0